// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Products_body__CjRkG {
  display: flex;
  justify-content: space-between;
}
.Products_body__CjRkG p {
  margin: 0;
}
.Products_body__CjRkG Button {
  margin-top: 16px;
  width: 100%;
}

.Products_products__RJaiA {
  margin-right: 24px;
}

.Products_product__CLydK {
  margin-bottom: 24px;
}

.Products_price-container__yKNqk {
  width: 25vw;
  max-width: 417px;
  min-width: 230px;
}

.Products_total-header__AQ17F {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
}

.Products_sticky__LLXi9 {
  position: sticky;
  top: 15vw;
}`, "",{"version":3,"sources":["webpack://./src/views/Products/Products.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,8BAAA;AAAJ;AACI;EACI,SAAA;AACR;AACI;EACI,gBAAA;EACA,WAAA;AACR;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,eC1BO;ED2BP,iBCxBG;ADwBP;;AAGA;EACI,gBAAA;EACA,SAAA;AAAJ","sourcesContent":["@use \"styles/typography\";\n.body {\n    display: flex;\n    justify-content: space-between;\n    p {\n        margin: 0;\n    }\n    Button {\n        margin-top: 16px;\n        width: 100%;\n    }\n}\n\n.products {\n    margin-right: 24px;\n}\n\n.product {\n    margin-bottom: 24px;\n}\n\n.price-container {\n    width: 25vw;\n    max-width: 417px;\n    min-width: 230px;\n}\n\n.total-header {\n    display: flex;\n    justify-content: space-between;\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n}\n\n.sticky{\n    position: sticky;\n    top:15vw;\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `Products_body__CjRkG`,
	"products": `Products_products__RJaiA`,
	"product": `Products_product__CLydK`,
	"price-container": `Products_price-container__yKNqk`,
	"total-header": `Products_total-header__AQ17F`,
	"sticky": `Products_sticky__LLXi9`
};
export default ___CSS_LOADER_EXPORT___;
